module.exports = __webpack_public_path__ + "static/media/1 10 sjenkestopp.11e87619.mp3";